import createModelInstance from 'utils/createModelInstance';
import validateForm from 'utils/validateForm';

const Pet = (petObj) => {
    let newPetObj = {
        id: '',
        firstName: '',
        lastName: '',
        type: '',
        breed: '',
        sex: '',
        size: '',
        weight: '',
        collected: '',
        detailsChecked: '',
        hadIssue: '',
        serviceType: '',
        customUnit: '',
    };

    newPetObj = createModelInstance(newPetObj, petObj);

    // Make weight a number
    newPetObj.weight = Number.isNaN(Number.parseFloat(newPetObj.weight)) ? '' : Number.parseFloat(newPetObj.weight);
    return {
        ...newPetObj,
        /**
         * Converts the data of a model to the format to display it in the custom table
         * mainly use in the confirmation pages
         */
        toCustomTable() {
            const data = [];
            if (this.id) {
                data.push(['Pet ID', this.id]);
            }
            data.push(
                ['Pet first name', this.firstName],
                ['Pet last name', this.lastName],
                ['Pet type', this.type],
                ['Breed', this.breed],
                ['Sex', this.sex],
                ['Weight (kg)', this.weight]
            );
            return data;
        },
        /**
         * Validates the data to submit, the keys/values are the required fields
         * 
         * @param {object} objOptions
         * 
         * @returns {Array} an string array of the fields with errors or empty array if it's valid
         */
        validateRequiredData(objOptions) {
            let formFields = {
                firstName: this.firstName,
                lastName: this.lastName,
                type: this.type,
                breed: this.breed,
                sex: this.sex,
                weight: this.weight,
            };

            // If the pet breed has custom unit, we must require it
            if (objOptions.hasCustomUnit) {
                formFields['customUnit'] = this.customUnit;
            }
            
            let requiredValidation = validateForm(formFields);

            // Map the error array
            requiredValidation = requiredValidation.map(validation => {
                return {
                    field: validation,
                    message: '',
                };
            });

            return requiredValidation;
        },
        getFullName() {
            let fullName = this.firstName ? this.firstName : '';
            fullName += this.lastName ? ` ${this.lastName}` : '';
            return fullName;
        }
    };
};

export default Pet;
